import React, { useEffect, useMemo } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FaBullhorn, FaTimes } from "react-icons/fa";

const AnnouncementPopupModal = ({ open, onClose, list = [], loading }) => {
  const top = useMemo(() => (Array.isArray(list) ? list.slice(0, 5) : []), [list]);

  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose?.();
    if (open) window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  return (
    <AnimatePresence>
      {open && (
        <>
          {/* Light Backdrop with Blur */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
            className="fixed inset-0 z-[999] bg-slate-900/40 backdrop-blur-sm"
          />

          <motion.div
            initial={{ opacity: 0, scale: 0.95, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.95, y: 10 }}
            className="fixed inset-0 z-[1000] flex items-center justify-center p-4"
          >
            <div className="w-full max-w-xl rounded-[2.5rem] bg-[#0B1D34] border border-blue-800/40 shadow-[0_30px_80px_rgba(0,0,0,.6)] overflow-hidden">
              
              {/* Header */}
              <div className="p-6 border-b border-blue-800/40 flex items-center justify-between bg-[#071523]">
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-yellow-400 to-amber-500 flex items-center justify-center shadow-xl shadow-yellow-500/30">
                    <FaBullhorn className="text-white text-lg" />
                  </div>
                  <div>
                    <h2 className="text-xl font-black text-white">Announcement</h2>
                    <p className="text-[10px] font-bold text-yellow-400 tracking-[0.25em]">Global Network Updates</p>
                  </div>
                </div>

                <button
                  onClick={onClose}
               className="w-11 h-11 rounded-xl bg-[#102744] border border-blue-800/40 text-slate-300 hover:text-yellow-400 hover:border-yellow-400/40 transition-all flex items-center justify-center"
                >
                  <FaTimes />
                </button>
              </div>

              {/* Body */}
              <div className="p-6">
                {loading ? (
                  <div className="space-y-3">
                    {[1, 2].map(i => <div key={i} className="h-24 bg-[#102744] rounded-3xl animate-pulse" />)}
                  </div>
                ) : top.length === 0 ? (
                  <div className="text-center py-10">
                    <p className="text-sm font-bold text-slate-300">No active bulletins found</p>
                  </div>
                ) : (
                  <div className="space-y-4 max-h-[50vh] overflow-y-auto pr-2 custom-scrollbar">
                    {top.map((a) => (
                      <div
                        key={a._id}
                       className="group rounded-3xl bg-[#071523] border border-blue-800/30 p-6 hover:border-yellow-400/30 hover:bg-[#102744] transition-all duration-300"
                      >
                        <div className="flex items-start justify-between gap-3">
                          <h3 className="text-[15px] font-black text-white group-hover:text-yellow-400 transition-colors">
                            {a.title}
                          </h3>
                          <span className="text-[9px] font-black text-yellow-400 bg-[#102744] px-3 py-1 rounded-full border border-yellow-400/20">
                            {a.createdAt ? new Date(a.createdAt).toLocaleDateString() : ""}
                          </span>
                        </div>
                        <p className="text-[13px] text-slate-300 font-medium mt-2 leading-relaxed">
                          {a.description}
                        </p>
                      </div>
                    ))}
                  </div>
                )}

                {/* Footer Action */}
                <div className="mt-8 flex items-center justify-between">
                  <div className="text-[10px] font-bold text-slate-500 uppercase tracking-widest">
                    Verified By 3Workers  
                  </div>
                  <button
                    onClick={onClose}
                    className="h-12 px-8 rounded-2xl bg-gradient-to-r from-yellow-400 to-amber-500 text-[#07111F] font-black text-[11px] uppercase tracking-widest shadow-xl shadow-yellow-500/30 hover:scale-105 hover:shadow-yellow-500/50 active:scale-95 transition-all duration-300"
                  >
                    Acknowledged
                  </button>
                </div>
              </div>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default AnnouncementPopupModal;